module.exports = __webpack_public_path__ + "img/country-insights-table.c4001797.jpg";